import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./locales/en/translation.json";
import translationPL from "./locales/pl/translation.json";
import translationES from "./locales/es/translation.json";
import translationES_ES from "./locales/es-ES/translation.json";
import translationDE from "./locales/de/translation.json";
import translationFR from "./locales/fr/translation.json";
import translationIT from "./locales/it/translation.json";
import translationPT from "./locales/pt/translation.json";
import translationPT_BR from "./locales/pt-BR/translation.json";
import translationUK from "./locales/uk/translation.json";
import translationNL from "./locales/nl/translation.json";
import translationSV from "./locales/sv/translation.json";
import translationDA from "./locales/da/translation.json";
import translationNB from "./locales/nb/translation.json";
import translationFI from "./locales/fi/translation.json";
import translationRO from "./locales/ro/translation.json";
import translationTR from "./locales/tr/translation.json";
import translationCS from "./locales/cs/translation.json";
import translationEL from "./locales/el/translation.json";
import translationSK from "./locales/sk/translation.json";
import translationHU from "./locales/hu/translation.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: translationEN,
      },
      pl: {
        translation: translationPL,
      },
      es: {
        translation: translationES,
      },
      "es-ES": {
        translation: translationES_ES,
      },
      de: {
        translation: translationDE,
      },
      fr: {
        translation: translationFR,
      },
      it: {
        translation: translationIT,
      },
      pt: {
        translation: translationPT,
      },
      "pt-BR": {
        translation: translationPT_BR,
      },
      uk: {
        translation: translationUK,
      },
      nl: {
        translation: translationNL,
      },
      sv: {
        translation: translationSV,
      },
      da: {
        translation: translationDA,
      },
      nb: {
        translation: translationNB,
      },
      fi: {
        translation: translationFI,
      },
      ro: {
        translation: translationRO,
      },
      tr: {
        translation: translationTR,
      },
      cs: {
        translation: translationCS,
      },
      el: {
        translation: translationEL,
      },
      sk: {
        translation: translationSK,
      },
      hu: {
        translation: translationHU,
      },
    },
    supportedLngs: ["en", "pl", "es", "es-ES", "de", "fr", "it", "pt", "pt-BR", "uk", "nl", "sv", "da", "nb", "fi", "ro", "tr", "cs", "el", "sk", "hu"],
    nonExplicitSupportedLngs: true,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      convertDetectedLanguage: (language) => language.replace(/^(no|nn)(?=-|$)/i, "nb"),
      order: ["querystring", "navigator"],
      lookupQuerystring: "lng",
      caches: [],
    },
  });

export default i18n;
